// https://www.figma.com/file/3ZegR4dmCPzLSPwphi5Z7s/Web-Framework?type=design&node-id=379-54924&mode=design&t=5dVWuOpicqbQVRlD-4
export var BREAKPOINTS = {
  base: 0,
  xs: 360,
  s: 640,
  m: 768,
  l: 1024,
  xl: 1200,
  xxl: 1536
};
//# sourceMappingURL=config.js.map